import "./swipeindicator.scss";
function SwipeIndicator() {
    return (
        <div className="swipe-hint">
            <span className="swipe-hint__arrow">→</span>
        </div>
    );
}
export default SwipeIndicator;
